import AnalystsModal from './components/AnalystsModal';
export type { AnalystsModalProps } from './components/AnalystsModal';
export default AnalystsModal;
